import { Badge, CircularProgress, styled } from '@mui/material';
import MuiButton from '@mui/material/Button';
import { colors } from '../../styles';

const Button = ({
  variant,
  text,
  onClick,
  width,
  iconStart,
  iconEnd,
  token,
  borderRadius = '10px',
  style,
  isLoading,
  disabled,
  maxWidth,
  padding,
  type = 'button',
  size = 'medium',
  className = ''
}) => {
  const StyledBtn = styled(MuiButton)(() => ({
    color: styles[variant].color,
    backgroundColor: styles[variant].backgroundColorAlt,
    textTransform: 'capitalize',
    '&:hover,:active': {
      backgroundColor: !disabled
        ? styles[variant].backgroundColorAlt
        : styles[variant].backgroundColor,
      color: !disabled ? styles[variant].colorAlt : styles[variant].color,
      boxShadow: 'none'
    },
    borderRadius: borderRadius,
    border: styles[variant].border,
    width: width ? width : maxWidth ? '100%' : 'fit-content',
    height: maxWidth ? '100%' : '',
    padding,
    ...style,
    ...token
  }));
  return (
    <StyledBtn
      type={type}
      variant='contained'
      onClick={e => {
        !disabled && onClick?.(e);
      }}
      endIcon={iconEnd}
      startIcon={iconStart}
      size={size}
      className={className}
    >
      {!isLoading ? text : <CircularProgress />}
    </StyledBtn>
  );
};

const styles = {
  white: {
    color: colors.back21,
    colorDis: colors.back21,
    colorAlt: colors.back21,
    border: 'none',
    backgroundColor: colors.whiteFF,
    backgroundColorAlt: colors.whiteFF
  },
  lime: {
    color: colors.back21,
    colorDis: colors.back21,
    colorAlt: colors.back21,
    border: 'none',
    backgroundColor: colors.lime02,
    backgroundColorAlt: colors.lime02
  },
  green: {
    color: colors.back21,
    colorDis: colors.back21,
    colorAlt: colors.back21,
    border: 'none',
    backgroundColor: colors.green61,
    backgroundColorAlt: colors.green61
  },
  dark21: {
    color: colors.whiteFF,
    colorDis: colors.whiteFF,
    colorAlt: colors.whiteFF,
    border: `1px solid ${colors.whiteFF}`,
    backgroundColor: colors.back21,
    backgroundColorAlt: colors.back21
  },
  purple: {
    color: colors.whiteFF,
    colorDis: colors.whiteFF,
    colorAlt: colors.whiteFF,
    border: `none`,
    backgroundColor: colors.purpleA5,
    backgroundColorAlt: colors.purpleA5
  },
  orange: {
    color: colors.whiteFF,
    colorDis: colors.whiteFF,
    colorAlt: colors.whiteFF,
    border: `none`,
    backgroundColor: colors.orange02,
    backgroundColorAlt: colors.orange02
  },
  yellow: {
    color: colors.back21,
    colorDis: colors.back21,
    colorAlt: colors.back21,
    border: `none`,
    backgroundColor: colors.yellow08,
    backgroundColorAlt: colors.yellow08
  },
  back36: {
    color: colors.whiteFF,
    colorDis: colors.whiteFF,
    colorAlt: colors.whiteFF,
    border: `none`,
    backgroundColor: colors.back36,
    backgroundColorAlt: colors.back36
  },
  blue: {
    color: colors.whiteFF,
    colorDis: colors.whiteFF,
    colorAlt: colors.whiteFF,
    border: `none`,
    backgroundColor: colors.skyBlueF6,
    backgroundColorAlt: colors.skyBlueF6
  }
};

export default Button;
